module.exports = __webpack_public_path__ + "static/media/Stand-Up-Sprint-1-Audio-1.a7027574.mp3";